export const TYPES_LIST = ['Repeat'];

export const REPEAT_PERIODS_LIST = ['Quarterly', 'Annually'];

export const REPEAT_STARTTYPES_LIST = ['COE Date'];

export const REPEAT_ENDTYPES_LIST = ['After 1 years', 'After 5 years', 'After 10 years'];



// WEBPACK FOOTER //
// ./src/Lots/Components/Maintenance/maintenance-enums.js